import { Component, OnChanges, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-modular-mechanical-connections',
    templateUrl: './modular-mechanical-connections.component.html',
    styleUrls: ['./modular-mechanical-connections.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class ModularMechanicalConnectionsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  returnAirLocationSelection!: GuruEntity;
  paintOptionsSelection!: GuruEntity;
  frontSupplySelection!: GuruEntity;
  topSupplySelection!: GuruEntity;
  leftSupplySelection!: GuruEntity;
  rightSupplySelection!: GuruEntity;
  universalSupplySelection!: GuruEntity;
  riserConnectionSelection!: GuruEntity;
  returnAirStyleSelection!: GuruEntity;
  outsideAirSelection!: GuruEntity;
  supplyTypeSelection!: GuruEntity;
  outsideAirLocationSelection!: GuruEntity;
  opposedBladeDamperSelection!: GuruEntity;
  sightBaffleSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  readonly pipeDetailImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.MECHANICAL_CONNECTIONS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.returnAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnLocation');
    this.paintOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPaintOptions');
    this.frontSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyFront');
    this.topSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyTop');
    this.leftSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyLeft');
    this.rightSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyRight');
    this.universalSupplySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyUniversal');
    this.riserConnectionSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserConn');
    this.returnAirStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnAirOptions');
    this.outsideAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAir');
    this.supplyTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyType');
    this.outsideAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USOutsideAirLocation');
    this.opposedBladeDamperSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyTypeOBD');
    this.sightBaffleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSightBaffle');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
      this.modelService.getCharacteristicValue(this.engineKey(), 'PipeDetailImage', 'FileName').subscribe(result => {
        this.pipeDetailImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
